import { Box, Grid, Typography } from "@mui/material";
import CustomCopyButton from "../../../../../../components/CustomCopyButton";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const AWSEntityCommonDetails = ({ entityData }) => {
  return (
    <>
      {entityData?.aws_common_data?.account_nickname && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Account</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            {entityData?.aws_common_data?.account_nickname && (
              <>
                <TextIntegrationStyle
                  title={""}
                  value={
                    entityData?.aws_common_data?.account_nickname +
                    " - " +
                    entityData?.aws_common_data?.account_id
                  }
                />
              </>
            )}
          </Box>
        </Box>
      )}
      {entityData?.aws_common_data?.org && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Organization</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            {entityData?.aws_common_data?.org && (
              <IntegrationImage name={"aws"} width={"30px"} />
            )}
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_common_data?.org}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.original_unique_id && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>ARN</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <Grid container gap={2} direction={"row"}>
              <Grid item xs={7}>
                {entityData?.original_unique_id && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.original_unique_id}
                  ></TextIntegrationStyle>
                )}
              </Grid>
              <Grid item xs={3}>
                <CustomCopyButton
                  copyTitle={"ARN"}
                  copyText={entityData?.original_unique_id}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
};

export default AWSEntityCommonDetails;
